
import Vue from "vue";
import Component from "vue-class-component";
import { apiHandler } from "@/services/api-handler";
import { Api } from "shared/api";

@Component
export default class LocationUpdater extends Vue {
  locations = [];

  async mounted() {
    await this.fetchLocations();
  }

  async fetchLocations() {
    try {
      const locationsResponse = await apiHandler(() => Api.locations.Get());
      this.locations = locationsResponse;
    } catch (error) {
         // eslint-disable-next-line no-console
      console.error("Error fetching locations:", error);
    }
  }

  async updateLocation(location) {
    try {
      const { id, percent, advertising, tech, monthly, email } = location;
      if (!id) {
         // eslint-disable-next-line no-console
        console.error("Location ID is undefined!");
        return;
      }
      const updatedLocation = await apiHandler(() =>
        Api.locations[id].Patch({ percent, advertising, tech, monthly, email })
      );
      this.fetchLocations(); // Refresh the list after update
    } catch (error) {
         // eslint-disable-next-line no-console
      console.error("Error updating location:", error);
    }
  }

  toggleReportType(location) {
    location.monthly = !location.monthly; // Toggle between true (monthly) and false (weekly)
    this.updateLocation(location); // Automatically update the location on toggle
  }
}
